import React, { useCallback } from 'react';
import { useMappedState } from 'redux-react-hook';
import img from './../../assets/images/loadboy.svg';
import './styles.scss';

export const Loading = (props: any) => {
  const mapState = useCallback(
    state => (state.loading.isLoading), //
    [] 
  );
  const isLoading = useMappedState(mapState);
  //const isLoading = true
  return (
    isLoading &&
    <div id="gloading" className={"loading-generic" + (isLoading ? " opened" : "")}>
      <div>
        <img src={img} />
        <div className="loading__text">
          <strong>¡Procesando Información!</strong> 
          <div>Calma, esta espera es necesaria.</div>
        </div>
        <i className="loading__rotating"></i>
      </div>
    </div>
  )
}
